import { useEffect } from 'react';

interface ToastProps {
  message: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  onDismiss: () => void;
  /** Milliseconds before it closes by itself. */
  duration?: number;
}

export const Toast = ({ message, actionLabel, onAction, onDismiss, duration = 6000 }: ToastProps) => {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, duration);
    return () => window.clearTimeout(timer);
  }, [onDismiss, duration, message]);

  return (
    <div
      role="status"
      className="fixed bottom-8 left-1/2 z-50 flex max-w-[calc(100vw-32px)] -translate-x-1/2 items-center gap-4 rounded-full bg-stone-900 py-3 pl-5 pr-3 text-sm text-white shadow-[0_10px_30px_rgba(28,25,23,0.25)]"
    >
      <span>{message}</span>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="h-9 rounded-full border-0 bg-transparent px-3.5 text-sm font-semibold text-blue-300 hover:bg-white/10"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};
